<template>
  <div v-if="visible" class="success-modal-overlay" @click.self="close">
    <div class="success-modal">
      <button class="close-btn" @click="close">
        <i class="fa fa-times"></i>
      </button>

      <div class="success-icon">
        <img src="/images/circle-checked.svg" alt="Success" />
      </div>
      
      <h3 class="title">{{ $t('auth.congratulations') }}</h3>
      <p class="description">{{ $t('auth.email_confirmed') }}</p>

      <div class="actions">
        <button class="btn-ok" @click="close">
          {{ $t('common.ok') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessConfirmModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

.success-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  backdrop-filter: blur(4px);
}

.success-modal {
  background: #2c3038;
  padding: 50px 40px 40px;
  border-radius: 16px;
  width: 440px;
  max-width: 90%;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
  position: relative;
  text-align: center;
  
  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    background: transparent;
    border: none;
    color: #8b92a7;
    font-size: 20px;
    cursor: pointer;
    padding: 5px;
    transition: all 0.2s;
    
    &:hover {
      color: #fff;
      transform: scale(1.1);
    }
  }
}

.success-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;

  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
}

.title {
  margin-bottom: 8px;
  font-family: $font-inter-bold;
  color: #ffffff;
  font-size: 32px;
  line-height: 1.2;
}

.description {
  display: block;
  margin-bottom: 40px;
  font-family: $font-inter-regular;
  color: #8b92a7;
  font-size: 16px;
  line-height: 1.5;
}

.actions {
  display: flex;
  justify-content: center;
  
  .btn-ok {
    width: 200px; // As per design roughly half width
    padding: 14px 0;
    font-size: 16px;
    border-radius: 12px;
    font-family: $font-inter-bold;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: none;
    background: #00d09c;
    color: #1e2128; // Text color on teal usually dark for contrast or white
    // Based on image it looks dark or white, let's go with dark for better legibility on bright teal
    
    &:hover {
      background: #00f2b6;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 208, 156, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }
}
</style>
